import * as React from 'react'

import { styled } from '@mui/material/styles'
import Button from '@mui/material/Button'

import * as theme from '../../../theme'
import { CircularProgress } from '@mui/material'

const CustomizeButton = styled(Button)({
  fontSize: 16,
  padding: '6px 12px',
  border: '1px solid',
  lineHeight: 1.5,
  color: theme.PRIMARY_BUTTON_FONT,
  backgroundColor: theme.PRIMARY_BUTTON,
  borderColor: theme.PRIMARY_BUTTON,
  borderRadius:10,
  fontFamily: [
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
  ].join(','),
  '&:hover': {
    backgroundColor: theme.PRIMARY_BUTTON,
    borderColor: theme.PRIMARY_BUTTON,
  },
  '&:active': {
    boxShadow: 'none',
    backgroundColor: theme.PRIMARY_BUTTON,
    borderColor: theme.PRIMARY_BUTTON,
  },
  '&:disabled': {
    boxShadow: 'none',
    backgroundColor: theme.PRIMARY_BUTTON,
    borderColor: theme.PRIMARY_BUTTON,
  }
})



export default function SubmitButton(props) {
  const {buttonText, name, loading=false, ...rest }  = props
  return (
      <CustomizeButton type='submit' disabled={loading} name={name} {...rest}>
        {
        loading?
        <CircularProgress sx={{ color: theme.PRIMARY_BUTTON_LOADER }} />:
        buttonText
        }
      </CustomizeButton>
  )
}